import { render, staticRenderFns } from "./RatingDistributorsTop.vue?vue&type=template&id=71439937&scoped=true"
import script from "./RatingDistributorsTop.vue?vue&type=script&lang=js"
export * from "./RatingDistributorsTop.vue?vue&type=script&lang=js"
import style0 from "./RatingDistributorsTop.vue?vue&type=style&index=0&id=71439937&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71439937",
  null
  
)

export default component.exports